function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import React, { Fragment, useState } from "react";
export default function TextWithStat(props) {
    var closeModal = function closeModal() {
        setIsModalOpen(false);
    };
    var openModal = function openModal() {
        setIsModalOpen(true);
    };
    var _props_statistic, _props_statistic1;
    var _useState = _sliced_to_array(useState(false), 2), isModalOpen = _useState[0], setIsModalOpen = _useState[1];
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14 mt-9 mb-10 md:my-16 lg:my-16"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-7xl mx-auto relative"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: clsx("flex flex-col md:flex-row md:flex-wrap", {
            "md:gap-x-12 xl:gap-x-20 items-start": !props.image
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("content-text", {
            "pt-2 md:pt-0 md:w-2/3 md:flex-1": !props.image,
            "mt-5 md:mt-0 md:gap-x-8 md:pt-8 md:flex md:items-start": props.image
        })
    }, props.image ? /*#__PURE__*/ React.createElement("div", {
        className: "mb-6 md:mb-7 md:w-[45%] rounded-l-2xl overflow-hidden relative"
    }, /*#__PURE__*/ React.createElement("img", {
        height: "446",
        src: "".concat(props.image),
        alt: "",
        className: "max-w-full w-full",
        loading: "lazy"
    }), props.embedLink && /*#__PURE__*/ React.createElement("div", {
        className: "absolute bottom-6 md:bottom-8 inset-x-0 text-center md:text-right md:left-[unset] md:right-9"
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: openModal,
        className: "button-primary py-2.5 inline-flex items-center justify-center border-gray-600 bg-white text-gray-600 hover:bg-gray-600 hover:text-white"
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18px",
        height: "18px",
        viewBox: "0 0 18 18",
        version: "1.1",
        className: "mr-2.5 shrink-0 relative -top-px"
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Play/Black"), /*#__PURE__*/ React.createElement("g", {
        id: "Symbols",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Button/Watch/White/Icon/Static",
        transform: "translate(-19.000000, -13.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Play/Black",
        transform: "translate(19.000000, 13.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M17.5,0.5 L17.5,17.5 L0.5,17.5 L0.5,0.5 L17.5,0.5 Z",
        id: "Path",
        stroke: "currentColor"
    }), /*#__PURE__*/ React.createElement("polygon", {
        id: "Path",
        fill: "currentColor",
        points: "6 5.11694 12.4718 9 6 12.8831"
    }))))), props.embedLink.label), /*#__PURE__*/ React.createElement(Transition, {
        appear: true,
        show: isModalOpen,
        as: Fragment
    }, /*#__PURE__*/ React.createElement(Dialog, {
        as: "div",
        className: "relative z-10",
        onClose: closeModal,
        "aria-label": "Modal"
    }, /*#__PURE__*/ React.createElement(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "fixed inset-0 bg-black bg-opacity-75"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "fixed inset-0 overflow-y-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex min-h-full items-center justify-center p-4 text-center"
    }, /*#__PURE__*/ React.createElement(Transition.Child, {
        as: Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0 scale-95",
        enterTo: "opacity-100 scale-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100 scale-100",
        leaveTo: "opacity-0 scale-95"
    }, /*#__PURE__*/ React.createElement(Dialog.Panel, {
        className: "w-full max-w-3xl relative text-left align-middle transition-all"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mt-2"
    }, /*#__PURE__*/ React.createElement("iframe", {
        width: "717",
        height: "403",
        src: "".concat(props.embedLink.target, "?autoplay=1"),
        title: "YouTube video player",
        allow: "autoplay; encrypted-media",
        allowFullScreen: true,
        className: "max-w-full"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "mt-4"
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: closeModal,
        className: "text-white absolute -top-10 md:-top-8 right-0 md:-right-4",
        "aria-label": "Close modal"
    }, /*#__PURE__*/ React.createElement(XMarkIcon, {
        className: "w-8 h-8"
    }))))))))))) : null, /*#__PURE__*/ React.createElement("div", {
        className: clsx("blue-angle relative", {
            "flex-1": props.image
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx('before:content-[""] before:block before:w-0.5 before:bg-blue-100 before:absolute before:top-[59px] before:right-0 before:h-12', {
            "pr-12 pt-5": !props.statistic,
            "pt-10 lg:pt-12": props.statistic
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("order-first w-full relative pr-8 md:pr-14")
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("mb-3.5 lg:mb-5 md:grid items-start", {
            "lg:grid-cols-2 md:gap-x-10": (props === null || props === void 0 ? void 0 : (_props_statistic = props.statistic) === null || _props_statistic === void 0 ? void 0 : _props_statistic.length) === 2,
            "lg:grid-cols-3 md:gap-x-6": (props === null || props === void 0 ? void 0 : (_props_statistic1 = props.statistic) === null || _props_statistic1 === void 0 ? void 0 : _props_statistic1.length) === 3
        })
    }, props.statistic && props.statistic.map(function(stat, key) {
        return stat ? /*#__PURE__*/ React.createElement("div", {
            key: key,
            className: clsx("h-full", {
                "md:mb-0": props.image,
                "text-center": props.statistic && props.statistic.length < 3
            })
        }, /*#__PURE__*/ React.createElement("span", {
            className: "block mb-1.5 text-3xl lg:text-4xl leading-none font-semibold font-heading text-blue-500"
        }, stat.statNumber), /*#__PURE__*/ React.createElement("span", {
            className: "block font-medium text-gray-200 pb-5"
        }, stat.statText)) : null;
    }))), /*#__PURE__*/ React.createElement("div", null, props.children))))))));
}
